import React from 'react';

import { Icon } from 'antd';

const CerchioSvg = () => (
  <svg width="13" height="13" viewBox="0 0 13 13">
	<g id="cerchio">
        <circle cx="6.5" cy="6.5" r="5.5" />
    </g>
  </svg>
);

const CieloTerraSvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
  <g id="ico-cieloterra">
  <rect y="4.73" width="13" height="9.27"/>
	<polygon points="6.5 0 13 4.73 6.5 4.73 0 4.73 6.5 0"/>
  </g>
</svg>
);

const PorzioniSvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
	<g id="ico-porzioni">
		<rect y="4.73" width="13" height="8.27"/><polygon points="6.5 4.73 13 4.73 13 0 6.5 4.73"/><polygon points="0 4.73 6.5 4.73 0 0 0 4.73"/>
	</g>
</svg>
);

const StellaSvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
	<g id="ico-stella">
        <polygon points="6.5 0.32 8.51 4.39 13 5.04 9.75 8.21 10.52 12.68 6.5 10.57 2.48 12.68 3.25 8.21 0 5.04 4.49 4.39 6.5 0.32" />
	</g>
</svg>
);

const DirectSvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
	<g id="ico-direct">
        <polygon points="0.5 0.5 0.5 12.5 6.5 6.5 0.5 0.5" />
        <polygon points="12.5 0.5 6.5 6.5 12.5 12.5 12.5 0.5" />
	</g>
</svg>
);

const QuadratoSvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
	<g id="ico-quadrato">
        <rect x="1" y="1" width="11" height="11" />
	</g>
</svg>
);

const RomboSvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
	<g id="ico-rombo">
        <rect x="1.9" y="1.9" width="9.19" height="9.19" transform="translate(6.5 -2.69) rotate(45)" />
	</g>
</svg>
);

const TriangoloSvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
	<g id="ico-triangolo">
        <polygon points="6.5 0.87 9.75 6.5 13 12.13 6.5 12.13 0 12.13 3.25 6.5 6.5 0.87" />
	</g>
</svg>
);

const CoreSvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
	<g id="ico-core">
        <path d="M6.5,0A6.5,6.5,0,1,0,13,6.5,6.5,6.5,0,0,0,6.5,0Zm0,10.83A4.33,4.33,0,1,1,10.83,6.5,4.33,4.33,0,0,1,6.5,10.83Z" />
        <circle cx="6.5" cy="6.5" r="2" />
	</g>
</svg>
);

const DevelopmentSvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
	<g id="ico-development">
        <path d="M11,6.42A4.51,4.51,0,0,1,7.5,10.8V1.08h-2V10.8A4.51,4.51,0,0,1,2,6.42H0a6.5,6.5,0,0,0,13,0Z" />
	</g>
</svg>
);

const OpportunisticSvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
	<g id="ico-opportunistic">
        <path d="M13,10.25v-1a6.5,6.5,0,0,0-13,0v1ZM6.5,4.75a4.51,4.51,0,0,1,4.39,3.5H2.11A4.51,4.51,0,0,1,6.5,4.75Z" />
	</g>
</svg>
);

const TrophySvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
	<g id="ico-trophy">
        <path d="M0,.38v1C0,1.69,0,9.31,6,12.5l.48.26L7,12.5c5.92-3.23,6-10.79,6-11.12v-1Zm10.91,2A15.42,15.42,0,0,1,10.64,4H2.33a15.09,15.09,0,0,1-.27-1.62ZM6.48,10.46A9,9,0,0,1,2.94,6H10A9.2,9.2,0,0,1,6.48,10.46Z" />
	</g>
</svg>
);

const ValueaddSvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
	<g id="ico-valueadd">
	<path d="M0,0V13H13V0ZM11,5.5H7.5V2H11ZM5.5,2V5.5H2V2ZM2,7.5H5.5V11H2ZM7.5,11V7.5H11V11Z"/>	</g>
</svg>
);

const HSctSvg = () => (
<svg width="42" height="13" viewBox="0 0 42 13">
	<g id="ico-hs-ct">
		<polygon className="cls-1" points="10 4.5 20 11.77 10 11.77 0 11.77 10 4.5" />
        <polygon className="cls-1" points="32 11.64 42 11.64 42 4.36 32 11.64" />
        <polygon className="cls-1" points="22 11.64 32 11.64 22 4.36 22 11.64" />
        <polygon points="22 2.1 22 0 32 7.37 32 9.47 22 2.1" />
        <polygon points="10 2.1 10 0 0 7.37 0 9.47 10 2.1" />
    </g>
</svg>
);

const HSporzSvg = () => (
<svg width="42" height="13" viewBox="0 0 42 13">
	<g id="ico-hs-porz">
		<polygon className="cls-1" points="10 4.36 20 11.64 10 11.64 0 11.64 10 4.36" />
        <polygon className="cls-1" points="32 11.64 42 11.64 42 4.36 32 11.64" />
        <polygon className="cls-1" points="22 11.64 32 11.64 22 4.36 22 11.64" />
        <polygon points="42 2.1 42 0 32 7.37 32 9.47 42 2.1" />
        <polygon points="20 7.37 20 9.47 10 2.1 10 0 20 7.37" />
    </g>
</svg>
);

const PinGenSvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
	<g id="pin-generali">
		<path d="M2,.87V8a1.24,1.24,0,0,0,.57,1l4.14,4,3.85-4a1.24,1.24,0,0,0,.54-1V.87A.87.87,0,0,0,10.18,0H2.82A.87.87,0,0,0,2,.87Z" />
    </g>
</svg>
);

const PinCompSvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
	<g id="pin-competitor">
		<path d="M11.05,4.55a4.55,4.55,0,0,0-9.1,0C2,7.06,6.5,13,6.5,13S11.05,7.06,11.05,4.55Z" />
    </g>
</svg>
);

const PinFotoSvg = () => (
<svg width="13" height="13" viewBox="0 0 13 13">
	<g id="pin-foto">
		<path d="M12.16,0H.84A.8.8,0,0,0,0,.74V9.26A.8.8,0,0,0,.84,10H4.13l2.46,3,2.29-3h3.28A.8.8,0,0,0,13,9.26V.74A.8.8,0,0,0,12.16,0ZM11.09,8.09H1.91V1.91h9.18Z" />    </g>
</svg>
);

const Cerchio = props => <Icon { ...{...props, className: `cerchio-icon cerchio ${props.className||""}`} } component={CerchioSvg} />;

const CieloTerra = props => <Icon { ...{...props, className: `custom-icon cieloterra ${props.className||""}`} } component={CieloTerraSvg} />;
const Porzioni = props => <Icon { ...{...props, className: `custom-icon porzioni ${props.className||""}`} } component={PorzioniSvg} />;

const Stella = props => <Icon { ...{...props, className: `custom-icon stella ${props.className||""}`} } component={StellaSvg} />;
const Direct = props => <Icon { ...{...props, className: `custom-icon direct ${props.className||""}`} } component={DirectSvg} />;
const Quadrato = props => <Icon { ...{...props, className: `custom-icon quadrato ${props.className||""}`} } component={QuadratoSvg} />;
const Triangolo = props => <Icon { ...{...props, className: `custom-icon triangolo ${props.className||""}`} } component={TriangoloSvg} />;
const Rombo = props => <Icon { ...{...props, className: `custom-icon rombo ${props.className||""}`} } component={RomboSvg} />;

const Core = props => <Icon { ...{...props, className: `custom-icon core ${props.className||""}`} } component={CoreSvg} />;
const Development = props => <Icon { ...{...props, className: `custom-icon development ${props.className||""}`} } component={DevelopmentSvg} />;
const Opportunistic = props => <Icon { ...{...props, className: `custom-icon opportunistic ${props.className||""}`} } component={OpportunisticSvg} />;
const Trophy = props => <Icon { ...{...props, className: `custom-icon trophy ${props.className||""}`} } component={TrophySvg} />;
const Valueadd = props => <Icon { ...{...props, className: `custom-icon valueadd ${props.className||""}`} } component={ValueaddSvg} />;

const HSct = props => <Icon { ...{...props, className: `custom-icon hs-ct ${props.className||""}`} } component={HSctSvg} />;
const HSporz = props => <Icon { ...{...props, className: `custom-icon hs-porz ${props.className||""}`} } component={HSporzSvg} />;

const PinGen = props => <Icon { ...{...props, className: `custom-icon pin-generali ${props.className||""}`} } component={PinGenSvg} />;
const PinComp = props => <Icon { ...{...props, className: `custom-icon pin-competitor ${props.className||""}`} } component={PinCompSvg} />;
const PinFoto = props => <Icon { ...{...props, className: `custom-icon pin-foto ${props.className||""}`} } component={PinFotoSvg} />;

export {Cerchio, CieloTerra, Porzioni
	,Stella, Quadrato, Rombo
	,Direct, Triangolo, Core
	,Development, Opportunistic, Trophy
	,Valueadd, HSct, HSporz
	,PinGen, PinComp, PinFoto
};

